import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/manage-config/table-set';
const list = () => {
	return Client.get('/admin/api/table-set');
};
const find = (tableNo) => {
	return Client.get(`/admin/api/table-set/${tableNo}`);
};
const create = (payload) => {
	return Client.post(`/admin/api/table-set`, payload);
};
const update = (tableNo, payload) => {
	return Client.put(`/admin/api/table-set/${tableNo}`, payload);
};
const remove = (tableNo) => {
	return Client.del(`/admin/api/table-set/${tableNo}`);
};
const removeCloud = (merchantId, branchId, tableNo) => {
	return Client.del(`${numbatUrl}/${merchantId}/${branchId}/${tableNo}`);
};
const listByLayout = () => {
	return Client.get('/admin/api/table-set/layout');
};
const listByLayoutCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/layout`);
};
const batch = (payload) => {
	return Client.put('/admin/api/table-set/batch-aspect', payload);
};
const batchCloud = (merchantId, branchId, payload) => {
	return Client.put(
		`${numbatUrl}/${merchantId}/${branchId}/batch-aspect`,
		payload
	);
};

export default {
	list,
	listByLayout,
	find,
	create,
	update,
	remove,
	batch,
	listByLayoutCloud,
	batchCloud,
	removeCloud,
};
